import type { BaseTemplateConfig } from "@anggunpraya-templates/base/app/schemas/template";
import { baseTemplateConfigSchema } from "@anggunpraya-templates/base/app/schemas/template";

/**
 * Helper typed untuk `app.config.template`.
 *
 * Utility ini menjadi pintu masuk resmi saat template mendefinisikan
 * `app.config.ts`, sehingga:
 * - shape config diverifikasi terhadap shared contract
 * - validasi runtime Zod tetap dijalankan
 * - refactor field shared gagal lebih cepat bila config belum sinkron
 *
 * @param config Konfigurasi template yang ingin divalidasi
 * @returns Konfigurasi template yang sudah lolos validasi contract shared
 *
 * @example
 * ```typescript
 * export const template = defineTemplateConfig({
 *   general: {
 *     groom_nickname: "A",
 *     bride_nickname: "B",
 *   },
 *   ...
 * });
 * ```
 */
export function defineTemplateConfig<TConfig extends BaseTemplateConfig>(config: TConfig) {
  return baseTemplateConfigSchema.parse(config) as TConfig;
}
